import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { BillOfMaterialsItemStatus } from "../../../clients/graphqlTypes.js";
import { BillOfMaterialsItemStatusLabel } from "./BillOfMaterialsItemStatus.js";

interface Props {
  item: {
    title: string;
    itemStatus: BillOfMaterialsItemStatus;
    quantityRequiredTotal: number;
    quantityOrdered: number;
  };
}

export function BillOfMaterialsListItem({
  item: { title, itemStatus, quantityRequiredTotal, quantityOrdered },
}: Props) {
  return (
    <Stack
      direction="column"
      spacing={0}
      sx={{
        flex: 1,
      }}
    >
      <Typography variant="body1">{title}</Typography>
      <Stack
        direction="row"
        spacing={1}
        sx={{
          alignItems: "center",
        }}
      >
        <BillOfMaterialsItemStatusLabel status={itemStatus} />
        <Typography variant="caption">{`ordered ${quantityOrdered}/${quantityRequiredTotal}`}</Typography>
      </Stack>
    </Stack>
  );
}

interface EditProps extends Props {
  Checkbox: React.ReactElement;
  QuantityInput: React.ReactElement;
}

export function BillOfMaterialsListItemEdit({
  item,
  Checkbox,
  QuantityInput,
}: EditProps) {
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        alignItems: "center",
      }}
    >
      {Checkbox}
      <BillOfMaterialsListItem item={item} />
      <Box
        sx={{
          maxWidth: "10ch",
        }}
      >
        {QuantityInput}
      </Box>
    </Stack>
  );
}
